<div class="col-md-12 mb-30" >
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Proficiency Test Calendar</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Title</label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_AzmoonMaharat()" class="btn btn-info" style="margin-right: 5px;"><i
              class="fa  fa-search"></i> Search </button>

          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Code</th>
              <th>Title</th>
              <th>Start</th>
              <th>End</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_AzmoonMaharat
            |filter:Filter_title:'title'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_AzmoonMaharat|filter:Filter_title:'title').length
                      }
            ">
              <td>{{DataList_AzmoonMaharat.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.title}}</td>
              <td>{{item.startDate}}</td>
              <td>{{item.endDate}}</td>
              <td>
                <span *ngIf="item.status.length==0">Inactive</span>
                <span *ngFor="let status of item.status">
                  {{status.title}}
                </span>
              </td>
              <td>
                <button (click)="openModal(template,item)"  type="button" class="btn btn-danger" >
                  Stages 
                </button>

                <button *ngIf="item.canSignIn && !Procssing" (click)="openModalSignIn(templateSignIn,item)"  type="button" class="btn btn-success" style="margin-left: 10px;">
                  Register
                </button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>

<ng-template #template>
  <div class="modal-header">
     <h4 class="modal-title pull-left">Proficiency Test Stages '{{Data_Seleted_Delete.title}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>

  <div class="modal-body">
    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>Start Date</th>
            <th>End Date</th>

          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of Data_Seleted_Delete.child">
            <tr>
              <td>{{Data_Seleted_Delete.child.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>{{item.startDate}}</td>
              <td>{{item.endDate}}</td>
            </tr>
            <tr *ngIf="item.file.length>0">
              <td colspan="3">
                <table class="mb-0 table table-bordered table-3 text-center table-striped">
                  <thead style="background-color: #39529b; color: white;">
                    <tr>
                      <th>#</th>
                      <th>Title</th>
                      <th>Template</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let file of item.file">
                      <td>{{item.file.indexOf(file)+1}}</td>
                      <td>{{file.title}}</td>
                      <td>
                        <a class="btn btn-danger" href="{{BaseUrl}}{{file.templateSrc}}" target="_blank">
                          View File
                        </a>
                      </td>
                    </tr>          
                  </tbody>
                </table>
              </td>
            </tr>
          </ng-container>

        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">

     <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateSignIn>
  <div class="modal-header">
     <h4 class="modal-title pull-left">Proficiency Test Registration: '{{Data_Seleted_Delete.title}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_SignIn.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body" *ngIf="Data_Seleted_Delete.canSignInCount>0">
    <p> You have registered for this test {{Data_Seleted_Delete.canSignInCount}} times. Would you like to register again? </p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="SignIn(Data_Seleted_Delete)">Register</button>
     <button type="button" class="btn btn-danger" (click)="modalRef_SignIn.hide()">Close</button>
  </div>
</ng-template>
